import styles from './AuditInfoPanel.module.css'

interface ExamplePhotoCarouselProps {
  exampleImages: string[]
  currentImageIndex: number
  sectionTitle: string
  onPreviousImage: () => void
  onNextImage: () => void
}

function ExamplePhotoCarousel({
  exampleImages,
  currentImageIndex,
  sectionTitle,
  onPreviousImage,
  onNextImage,
}: ExamplePhotoCarouselProps) {
  return (
    <div className={styles.examplePhotoSection}>
      <h3 className={styles.sectionLabel}>
        Example Photo{exampleImages.length > 1 ? 's' : ''}
        {exampleImages.length > 1 && (
          <span className={styles.imageCounter}>
            {currentImageIndex + 1} / {exampleImages.length}
          </span>
        )}
      </h3>
      {exampleImages.length > 0 ? (
        <div className={styles.imageCarousel}>
          {exampleImages.length > 1 && (
            <button
              className={`${styles.carouselArrow} ${styles.carouselArrowLeft}`}
              onClick={onPreviousImage}
              aria-label='Previous image'
            >
              ‹
            </button>
          )}
          <img
            src={exampleImages[currentImageIndex]}
            alt={`Example ${currentImageIndex + 1} for ${sectionTitle}`}
            className={styles.exampleImage}
          />
          {exampleImages.length > 1 && (
            <button
              className={`${styles.carouselArrow} ${styles.carouselArrowRight}`}
              onClick={onNextImage}
              aria-label='Next image'
            >
              ›
            </button>
          )}
        </div>
      ) : (
        <div className={styles.photoPlaceholder}>
          <p>No example photo available for this section</p>
        </div>
      )}
    </div>
  )
}

export default ExamplePhotoCarousel
